<template>
  <div>
    <div :class="$style.box">
      <!-- 活动介绍 -->
      <Introduction v-show="introShow" @changeIntroShow="introChange"></Introduction>
      <!-- 页面标题 -->
      <Title :name="name" :type="2"></Title>
      <!-- 问题按钮 -->
      <img :class="$style.question" :src="question" @click="introChange" alt />
      <!-- 表单验证 -->
      <div :class="$style.bind">
        <Field
          :class="$style.field"
          v-model.trim="formData.acc"
          :type="1"
          :pic="accIcon"
          :placeHolder="accPlaceHolder"
        ></Field>
        <Field
          :class="$style.field"
          v-model.trim="formData.pass"
          :type="1"
          :pic="passIcon"
          :placeHolder="passPlaceHolder"
          :inputType="'password'"
        ></Field>
        <div :class="$style.sure" @click="submit">确认绑定</div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Title from "@/components/Title.vue";
import Field from "@/components/Field.vue";
import Introduction from "@/components/Introduction.vue";
import { CDN_URL } from "@/config";
import { mapMutations, mapActions, mapState } from "vuex";
import { Toast } from "vant";
import { sort_ASCII } from "@/libs/utils";

export default {
  data() {
    return {
      name: "账号绑定", // 页面title
      question: `${CDN_URL}/packet/question.png`, // 问题icon
      accIcon: `${CDN_URL}/packet/acc.png`, // 账号icon
      accPlaceHolder: "请输入您的账号",
      passIcon: `${CDN_URL}/packet/password.png`, // 密码icon
      passPlaceHolder: "请输入您的密码",
      formData: {
        acc: "",
        pass: ""
      },
      introShow: false, // 活动介绍显示控制
    };
  },
  components: {
    Title,
    Field,
    Introduction
  },
  computed: {
    ...mapState("packet", {
      userInfo: "userInfo"
    })
  },
  methods: {
    ...mapMutations("packet", {
      SHOW_TIP: "SHOW_TIP",
      HIDDEN_TIP: "HIDDEN_TIP",
      CHANGE_USERINFO: "CHANGE_USERINFO"
    }),
    ...mapActions("packet", {
      userBind: "userBind"
    }),
    async submit() {
      if (!this.formData.acc) {
        Toast("账号不能为空", 2000);
        return;
      }
      if (!this.formData.pass) {
        Toast("密码不能为空", 2000);
        return;
      }
      // 用户登录
      const pass = CryptoJS.MD5(this.formData.pass).toString().toLowerCase();
      const data = {
        user_name: this.formData.acc,
        password: CryptoJS.MD5(this.formData.pass + pass).toString().toLowerCase(),
        open_id: this.userInfo.open_id
      };
      const r = await this.userBind({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        this.CHANGE_USERINFO({ userInfo: r.content });
        console.log("login bind", this.userInfo);
        this.$router.push({ name: "role" });
      }
      return;
    },
    introChange() {
      this.introShow = !this.introShow;
    },
    test() {
      const tips = {
        tip_title: "测试",
        tip_info: [
          "*开服首日内游戏角色转生达到4转 10元现金； ",
          "*开服7天内游戏角色转生达到14转 100元现金；",
          "*开服15天内游戏角色转生达到21转 1000元现金；",
          "*开服30天内游戏角色转生达到25转 华为P30pro (256G)一台；"
        ]
      };
      this.SHOW_TIP(tips);
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  .question {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 20px;
    top: 60px;
  }
  .bind {
    width: 100%;
    height: 240px;
    // background-color: pink;
    position: absolute;
    top: 180px;
    box-sizing: content-box;
    .field {
      margin-top: 20px;
      margin-left: 50%;
      transform: translateX(-113px);
    }
    .sure {
      width: 226px;
      height: 42px;
      background: rgba(255, 206, 100, 1);
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 30px;
    }
  }
}
</style>